import styles from "./Results.module.css";
import { ResultOption } from "../../lib/api/models";
import StyledRadioButton from "../common/inputs/StyledRadioButton";
import classNames from "classnames";

const strings = {
  contact: "Contact",
};

type Props = {
  hasPermissionToDiscuss: boolean;
  selectedOption: ResultOption | null;
  options: ResultOption[];
  onChange: (v: ResultOption) => void;
};

const wrapThreshold = 5;
const p2dWrapThreshold = 3;

export default function ContactFieldset({
  hasPermissionToDiscuss,
  selectedOption,
  options,
  onChange,
}: Props) {
  if (options.length === 0) {
    return null;
  }

  const shouldWrap =
    options.length > wrapThreshold ||
    (hasPermissionToDiscuss && options.length > p2dWrapThreshold);

  return (
    <fieldset
      className={classNames(styles.headerFieldset, {
        [styles.contactPersonWithP2D]: hasPermissionToDiscuss,
        [styles.headerFieldsetWrapped]: shouldWrap,
      })}
    >
      <div
        className={classNames(styles.label, styles.headerLabel)}
        aria-hidden={true}
      >
        {strings.contact}
      </div>
      <legend className={styles.visuallyHidden}>{strings.contact}</legend>
      <div
        className={classNames({
          [styles.radioButtonRowWrap]: shouldWrap,
          [styles.radioButtonRow]: true,
        })}
      >
        {options.map((item) => (
          <StyledRadioButton
            key={item.id}
            label={item.description}
            value={item.value}
            checked={selectedOption?.id === item.id}
            onChange={() => onChange(item)}
            className={classNames({
              [styles.radioButtonWrap]: shouldWrap,
              [styles.radioButton]: true,
            })}
          />
        ))}
      </div>
    </fieldset>
  );
}
